// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uDF9","colBig":"styles_colBig__109hv","colSmall":"styles_colSmall__394rm","shopifyNameWrapper":"styles_shopifyNameWrapper__1qbQw"};